document.addEventListener('DOMContentLoaded', function () {
  const banners = document.querySelectorAll('.banner-item');
  const slider = document.querySelector('.banner-slider');
  const now = new Date();

  let visibleCount = 0;

  banners.forEach(banner => {
    const start = banner.dataset.start;
    const end = banner.dataset.end;

    let show = true;

    // check start date
    if (start) {
      const startDate = new Date(start);
      if (!isNaN(startDate) && now < startDate) {
        show = false;
      }
    }

    // check end date
    if (end) {
      const endDate = new Date(end);
      if (!isNaN(endDate) && now >= endDate) {
        show = false;
      }
    }

    if (!show) {
      banner.remove(); // 🔥 penting: remove dari DOM, bukan hide
    } else {
      visibleCount++;
    }
  });

  // kalau semua banner ke-remove → inject placeholder
  if (visibleCount === 0 && slider) {
    slider.innerHTML = `
      <div class="banner-item slide">
        <picture>
          <source 
            media="(max-width: 767px)" 
            srcset="https://cdn.shopify.com/s/files/1/0599/9149/0627/files/placeholder-mobile.webp?v=1777976959"
          >
          <source 
            media="(min-width: 768px)" 
            srcset="https://cdn.shopify.com/s/files/1/0599/9149/0627/files/placeholder-dekstop.webp?v=1777976960"
          >
          <img
            src="https://cdn.shopify.com/s/files/1/0599/9149/0627/files/placeholder-dekstop.webp?v=1777976960"
            alt="Placeholder Banner"
            title="Placeholder Banner"
            width="100%"
            height="100%"
          >
        </picture>
      </div>
    `;
  }
  $('.banner-slider').slick({
    dots: true,
    arrows: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000
  });
});